import { COMPONENT_TYPES } from '../../../constants';
import MembershipSignupComponent from './MembershipSignup.component';
import MembershipSignupEditor from './MembershipSignup.editor';
import MembershipSignupProperties from './MembershipSignup.properties';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.MEMBERSHIP_SIGNUP, // constants.js에 정의된 타입 상수
  component: MembershipSignupComponent,
  editorComponent: MembershipSignupEditor,
  properties: MembershipSignupProperties,
  defaultProps: {
    style: {
      padding: '40px 20px',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      maxWidth: '800px',
      margin: '0 auto',
    },
    componentProps: {
      className: 'membership-signup-wrapper',
      title: '멤버십 가입신청',
      buttonText: '가입 신청',
      completedText: '가입 완료',
      description: '멤버십에 가입하시면 다양한 혜택을 받으실 수 있습니다.',
      productId: 0 // 상품 ID는 기본값으로 0 설정
    }
  },
  category: 'advanced', // 컴포넌트 카테고리
  icon: '🎖️', // 대표 아이콘
  name: '멤버십 가입' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as MembershipSignupComponent } from './MembershipSignup.component';
export { default as MembershipSignupEditor } from './MembershipSignup.editor';
export { default as MembershipSignupProperties } from './MembershipSignup.properties';
export * from './MembershipSignup.types'; 